/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetAirConditionerPathParameters } from 'api/actions/get-air-conditioner/get-air-conditioner-path-parameters';
import { GetAirConditionerResponse } from 'api/actions/get-air-conditioner/get-air-conditioner-response';

type GetAirConditionerQueryParameters = Record<string, any>;

/**
 * The path of the GetAirConditioner action.
 */
export const getAirConditionerActionPath = new SweetPath<keyof GetAirConditionerPathParameters>(
  '/air-conditioners/{airConditionerId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetAirConditioner actions.
 */
export default function createGetAirConditionerAction(axios: AxiosInstance) {
  return function getAirConditionerAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetAirConditionerPathParameters;
    query?: GetAirConditionerQueryParameters;
  }) {
    const path = getAirConditionerActionPath.insert(parameters);

    return axios.get<GetAirConditionerResponse, GetAirConditionerResponse>(path, { params: query, headers });
  };
}
